import AppError from './models/common/res/AppError';
import { ProductEvent } from './models/products/res/ProductEvent';
import { Product } from './models/products/res/Product';
import { request, Rows } from './request';
import { ProductCategory } from './models/products/res/ProductCategory';
import { FetchProductListQuery } from './models/products/req/FetchProductListQuery';
import { ProductFilter } from './models/products/res/ProductFilter';
import { ValidateProductOptionsBody } from './models/products/req/ValidateProductOptionsBody';
import { ProductOptionValidationRow } from './models/products/res/ProductOptionValidation';

export const fetchProductFilters = async (
  partnerCode: string,
  languageCode?: string,
  isTempData?: boolean,
) => {
  const eventUrl = `/app/events/events`;
  const categoryUrl = `/app/product-categories`;

  const filters: ProductFilter[] = [];

  try {
    const { data } = await request<Rows<ProductEvent>>({
      method: 'get',
      url: eventUrl,
      queryParams: {
        partnerCode,
        languageCode,
        isTempData,
      },
    });
    const { rows } = data;

    rows.forEach((event) => {
      const { id, eventTitle } = event;
      filters.push({
        id,
        isEvent: true,
        name: eventTitle,
        event,
      });
    });
  } catch (e) {}

  try {
    const { data } = await request<Rows<ProductCategory>>({
      method: 'get',
      url: categoryUrl,
      queryParams: {
        partnerCode,
        languageCode,
        isTempData,
      },
    });
    const { rows } = data;
    rows.forEach((category) => {
      const { id, productCategoryName } = category;
      filters.push({
        id,
        name: productCategoryName,
        isEvent: false,
      });
    });
  } catch (e) {}

  return filters;
};

export const fetchProducts = async (
  query: FetchProductListQuery,
): Promise<Product[]> => {
  const url = `/mini-web/products`;
  try {
    const { data } = await request<Rows<Product>>({
      method: 'get',
      url,
      queryParams: query,
    });

    const { rows } = data;
    // GA 상품명 저장을 위해 옵션 레벨에 상품명 추가
    return rows.map((product) => {
      const { productName, categoryName, event } = product;
      let eventName = '';
      if (event) {
        eventName = event.eventTitle;
      }
      return {
        ...product,
        productOptions: product.productOptions.map((option) => {
          return {
            ...option,
            productName,
            categoryName,
            eventName,
          };
        }),
      };
    });
  } catch (e) {
    throw new AppError(e);
  }
};

export const validateProductOptions = async (
  partnerCode: string,
  body: ValidateProductOptionsBody,
): Promise<Rows<ProductOptionValidationRow>> => {
  const url = `/mini-web/product-options/validation`;
  try {
    const { data } = await request<Rows<ProductOptionValidationRow>>({
      method: 'post',
      url,
      queryParams: { partnerCode },
      requestBody: body,
    });
    return data;
  } catch (e) {
    throw new AppError(e);
  }
};
